/*
 *
 * Terms actions
 *
 */

import {
  FETCH_TERMS_REQUEST,
  FETCH_TERMS_SUCCESS,
  FETCH_TERMS_FAILURE,
} from './constants';

export const fetchTermsRequest = () => ({
  type: FETCH_TERMS_REQUEST,
});

export const fetchTermsSuccess = (payload) => ({
  type: FETCH_TERMS_SUCCESS,
  payload,
});

export const fetchTermsFailure = () => ({
  type: FETCH_TERMS_FAILURE,
});



// WEBPACK FOOTER //
// ./src/containers/TermsPage/actions.js